export default "__VITE_ASSET__0da176ba__"